<template lang="pug">
  .colorbar-locations-directory.row.xs-f-small.max-at-tweak
    .xs-12
      .hcb-locations-title-wrap
        h3.bold.full-title.xs-hide.sm-hide Browse directory of all Hair Color Bars:
        h3.bold.short-title.md-hide.lg-hide All Hair Color Bars:

      .hcb-directory-accordion.xs-12
        template(v-if="regionsWithActiveLocations.length")
          .accordion-section.xs-12.sm-6.md-4.lg-3(v-for="(region, index) in regionsWithActiveLocations" :key="`region-${index}`" :class="getSectionClasses(region)")
            button.btn-reset.header-wrap.xs-12(
              :class="{'open': sectionIsOpen(region)}"
              :tabindex="!isDesktop || sectionIsOpen(region) ? 0 : -1"
              @click.stop="openSection(region, `Locations Directory Region ${sectionIsOpen(region) ? 'Closed' : 'Opened'}`)"
            )
              a.header-text.semi-bold.xs-f-mediumxx(
                @click.stop="isDesktop && trackMREventAndRedirect('Locations Directory Region Clicked', `/colorbar/regions/${region.url_key}`)"
                tabindex="0"
                :href="`/colorbar/regions/${region.url_key}`"
                :class="{'underline': isDesktop}"
              ) {{ region.name }} ({{ region.numActiveLocations }})

              span.thin.big-caret.md-f-xxxsmall.lg-f-xxxsmall.icon-caret-down(
                v-if="isMobile"
                :class="{'animate-caret-down': sectionIsOpen(region), 'animate-caret-up': !sectionIsOpen(region)}"
              )

            .links-wrap.xs-12(v-if="!isMobile || sectionIsOpen(region)" :aria-expanded="isDesktop || sectionIsOpen(region)" :aria-hidden="!isDesktop")
              ul.subsection-wrap
                li.subsection(v-for="(location, index) in region.locationSummaries" :key="`link-${index}`" v-if="location.active")
                  a.subsection-link(:href="location.url" target="_self" :tabindex="isDesktop || sectionIsOpen(region) ? 0 : -1" @click="trackIfRequired(location)")
                    | {{ location.name }}
          template(v-if="showEmptyColumnCount")
            .accordion-section.xs-hide.sm-hide.md-4.lg-3(v-for="index in showEmptyColumnCount" :key="`empty-region-${index}`")
        template(v-else)
          .accordion-section.xs-12.sm-6.md-4.lg-3(v-for="index in 22" :key="`empty-region-${index}`")
            .header-wrap.xs-12
              .ssc-line
            .links-wrap.xs-12
              ul.subsection-wrap
                li.subsection
                  .subsetion-link.ssc-line
                  .subsetion-link.ssc-line
                  .subsetion-link.ssc-line
                  .subsetion-link.ssc-line
                  .subsetion-link.ssc-line
                  .subsetion-link.ssc-line
</template>
<script>
  import { getAllRegions } from '@services/vueColorbarSvc';
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'ColorBarLocationsDirectory',

    data() {
      return {
        regions: [],
        openSectionTitles: [],
      };
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapGetters('siteNav', ['showMensMenu']),

      isMobile() {
        return this.windowData.breakpoint === 'mobile';
      },

      isDesktop() {
        return this.windowData.breakpoint === 'desktop' || this.windowData.breakpoint === 'desktop-md';
      },

      showEmptyColumnCount() {
        let columnsWidthMap = {
          mobile: 12,
          tablet: 6,
          'desktop-md': 4,
          desktop: 3,
        };

        return this.regionsWithActiveLocations.length % columnsWidthMap[this.windowData.breakpoint];
      },

      regionsWithActiveLocations() {
        return this.regions.filter(region => region.numActiveLocations);
      }
    },

    mounted() {
      getAllRegions().then(res => this.regions = res.data);
    },

    methods: {
      getSectionClasses(section) {
        const classes = [];
        if (this.sectionIsOpen(section)) {
          classes.push('open');
        }
        return classes.join(' ');
      },

      async trackIfRequired(link) {
        this.trackMREventAndRedirect(link.trackEventName, link.url);
      },

      openSection(section, trackEventName) {
        if (this.isDesktop) {
          return;
        }

        if (this.sectionIsOpen(section)) {
          this.openSectionTitles.splice(this.openSectionTitles.indexOf(`${section.name}`.toLowerCase()), 1);
        } else {
          this.openSectionTitles.push(`${section.name}`.toLowerCase());
        }

        if (trackEventName) {
          this.trackMREvent(trackEventName);
        }
      },

      sectionIsOpen(section) {
        return this.openSectionTitles.includes(`${section.name}`.toLowerCase());
      }
    },
  };
</script>
<style lang="stylus" scoped>
  .colorbar-locations-directory
    width 100%
    overflow visible
    padding 0 5%
    padding-top 35px
    border-bottom 1px solid color-gray

    @media mq-tablet-less
      padding 0
      border-bottom unset

    .hcb-locations-title-wrap
      padding-bottom 4%

      @media mq-tablet-less
        padding 1.4em 1.1em

    .hcb-directory-accordion
      display flex
      flex-wrap wrap
      align-items flex-start
      padding-bottom 1em

      @media mq-tablet-less
        padding 0em 0.9em

      .accordion-section
        flex 1 auto
        margin-bottom 24px
        padding-left 5px
        padding-right 5px

        @media mq-tablet-less
          border-top 1px solid ui-color-5
          border-bottom none
          margin-bottom 0px

          &:last-child
            border-bottom 1px solid ui-color-5

        .links-wrap
          @media mq-tablet-less
            padding 0px 8px

        .header-wrap
          cursor pointer
          text-decoration underline
          margin-bottom 8px

          &.open
            background-color white

          @media mq-tablet-less
            padding 0.9em 0.1em
            text-decoration none
            margin-bottom 0px

          .header-text
            display flex
            align-items center
            justify-content space-between
            color #333
            float left

          .big-caret
            float right

            &.animate-caret-down:before
              transform rotate(0deg)
              transition transform 400ms ease

            &.animate-caret-up:before
              transform rotate(-180deg)
              transition transform 400ms ease

            &.h-animated:active::before
              animation horizontal-bounce 0.4s
              animation-direction alternate
              animation-timing-function cubic-bezier(.7, .2, 1, .7)
              animation-iteration-count infinite

      .links-wrap
        .subsection
          padding-bottom 4px

          @media mq-tablet-less
            padding 0.9em 0em

          .subsection-link
            color text-color-3
</style>
